// @ts-nocheck

class MMCartRemoveButton extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('mm-cart-items') || this.closest('mm-cart-drawer-items');
        cartItems?.updateQuantity(this.dataset.index, 0, null, this);
      });
    }
}
  
customElements.define('mm-cart-remove-button', MMCartRemoveButton);

class MMCartItems extends HTMLElement {
    cartUpdateUnsubscriber = undefined;

    constructor() {
        super();

        this.init();
        this.addEventListener('change', theme.utils.debounce(this.onChange.bind(this), 300));
        this.cartUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
    }

    init() {
        this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

        // Progress Bar
        this.bxgyBar = document.getElementById('bxgy-progress');
        this.giftsIds = new Set();
        this.bxgyBar?.querySelectorAll('.js-promotion-item').forEach(item => {
            const productId = item.getAttribute('data-product-id');
            if (productId) this.giftsIds.add(Number(productId));
        });

        // Upsell Products
        this.upsellProducts = document.querySelectorAll('.cart-upsell-wrapper .upsell-product-item');
        const jsonText = document.querySelector('.cart-upsell-wrapper .js-upsell-products-json')?.textContent;
        this.upsellProductsJson = jsonText ? JSON.parse(jsonText) : null;

       this.initCartJSON();
       this.handleUpsellProducts();

       this.addEventListener('change', (event) => {
            if (event.target.classList.contains('js-subscribe-toggle')) {
                this.onSubscribeToggle(event.target.checked);
            }
        });
    }

    async getCartJSON() {
        const response = await fetch('/cart.js');
        if (!response.ok) {
          throw new Error('Failed to fetch cart');
        }
        return response.json();
    }

    async initCartJSON() {
        try {
            const cart = await this.getCartJSON();
            this.filterUpsellProducts(cart);
            this.updateProgressBar(cart);
        } catch (error) {
          console.error('Error initCartJSON():', error);
        }
    }

    updateProgressBar(cartJson) {
        const container = this.bxgyBar;
        const elements = {
            container,
            fill: container?.querySelector('#progressFill'),
            message: container?.querySelector('#bxgy-progress-message')
        };

        if (!elements.container || !elements.fill || !cartJson) return;
    
        const promotionItems = elements.container.querySelectorAll('.js-promotion-item');
        if (!promotionItems.length) return;

        const giftItems = (cartJson.items || []).filter(i => i.properties?._progressbar_promotion);
        const giftTotal = giftItems.reduce((sum, i) => sum + (i.original_line_price || 0), 0);
        const giftCount = giftItems.reduce((sum, i) => sum + (i.quantity || 0), 0);

        const cartTotal = (cartJson.original_total_price - giftTotal) / 100;
        const cartItemCount = Math.max((cartJson.item_count || 0) - giftCount, 0);
        const valueForType = (type) => (type === 'items' ? cartItemCount : cartTotal);

        const thresholds = Array.from(promotionItems)
            .map(item => {
                const thresholdType = this.getAttr(item, 'data-threshold-type') || 'price';
                return {
                    element: item,
                    threshold: this.getAttr(item, 'data-threshold', true),
                    thresholdType,
                    currentValue: valueForType(thresholdType),
                    productId: this.getAttr(item, 'data-product-id', true),
                    discountCode: this.getAttr(item, 'data-discount-code'),
                    wasReached: item.classList.contains('reached'),
                    discountMessage: item.getAttribute('data-discount-message')
                };
            })
            .filter(t => t.threshold !== null && t.threshold > 0);

        if (!thresholds.length) return;

        thresholds.forEach((tier) => {
            tier.element.style.position = '';
            tier.element.style.left = '';
            tier.element.style.transform = '';
        });

        const promotionWrapper = elements.container.querySelector('.promotion-wrapper');
        const trackRect = elements.fill.parentElement.getBoundingClientRect();
        const trackWidth = trackRect.width || 1;
        const promotionRect = (promotionWrapper || elements.fill.parentElement).getBoundingClientRect();

        thresholds.forEach((tier, index) => {
            const itemRect = tier.element.getBoundingClientRect();
            const itemCenterX = itemRect.left + itemRect.width / 2;
            const offsetFromTrackLeft = itemCenterX - trackRect.left;
            const fallback = ((index + 1) / thresholds.length) * 100;
            const measured = trackWidth > 0 && promotionRect.width > 0
                ? (offsetFromTrackLeft / trackWidth) * 100
                : fallback;
            tier.visualPosition = Math.max(0, Math.min(100, measured));
        });

        thresholds.sort((a, b) => a.visualPosition - b.visualPosition);

        const state = {
            productsToAdd: [],
            productsToRemove: [],
            discountsToApply: [],
            discountsToRemove: [],
            nextTier: null,
            nextTierDiscountMessage: null
        };

        thresholds.forEach(tier => {
            const isReached = tier.currentValue >= tier.threshold;
            tier.isReached = isReached;
            tier.element.classList.toggle('reached', isReached);

            if (isReached) {
                if (!tier.wasReached) {
                    if (tier.productId) state.productsToAdd.push(tier.productId);
                    if (tier.discountCode) state.discountsToApply.push(tier.discountCode);
                }
            } else {
                if (!state.nextTier) state.nextTier = tier;
                if (tier.wasReached) {
                    if (tier.productId) state.productsToRemove.push(tier.productId);
                    if (tier.discountCode) state.discountsToRemove.push(tier.discountCode);
                }
            }
        });

        state.discountsToApply.forEach(code => this.applyDiscountCode(code, cartJson));
        state.discountsToRemove.forEach(code => this.removeDiscountCode(code, cartJson));
        state.productsToAdd.forEach(productId => this.addProduct(productId, cartJson));
        state.productsToRemove.forEach(productId => this.removeProduct(productId, cartJson));

        let progressPercent;
        const allReached = thresholds.every(t => t.isReached);
        if (allReached) {
            progressPercent = 100;
        } else {
            let prevPosition = 0;
            let prevTier = null;
            progressPercent = 0;
            for (let i = 0; i < thresholds.length; i++) {
                const tier = thresholds[i];
                if (!tier.isReached) {
                    let ratio;
                    if (prevTier && prevTier.thresholdType === tier.thresholdType) {
                        const span = tier.threshold - prevTier.threshold;
                        ratio = span > 0
                            ? (tier.currentValue - prevTier.threshold) / span
                            : 0;
                    } else {
                        ratio = tier.threshold > 0 ? tier.currentValue / tier.threshold : 0;
                    }
                    ratio = Math.max(0, Math.min(1, ratio));
                    progressPercent = prevPosition + ratio * (tier.visualPosition - prevPosition);
                    break;
                }
                prevPosition = tier.visualPosition;
                prevTier = tier;
            }
        }

        elements.fill.style.width = `${Math.max(0, Math.min(100, progressPercent))}%`;
    }

    async onSubscribeToggle(isSubscribed) {
        const cartItemsContainer = document.getElementById('CartDrawer-CartItems');
        cartItemsContainer?.classList.add('cart__items--disabled');

        try {
            const cartJson = await this.getCartJSON();
            const cartItemEls = this.querySelectorAll('.mm-cart-item[data-first-selling-plan-id]');
            const sellingPlanMap = {};
            cartItemEls.forEach(el => {
                const index = parseInt(el.dataset.index);
                sellingPlanMap[index] = el.dataset.firstSellingPlanId;
            });

            const updates = [];

            for (let i = 0; i < cartJson.items.length; i++) {
                const item = cartJson.items[i];
                const line = i + 1;
                const sellingPlanId = sellingPlanMap[line];

                if (!sellingPlanId) continue;

                const hasSellingPlan = !!item.selling_plan_allocation;

                if (isSubscribed && !hasSellingPlan) {
                    updates.push({
                        line,
                        quantity: item.quantity,
                        selling_plan: parseInt(sellingPlanId),
                    });
                } else if (!isSubscribed && hasSellingPlan) {
                    updates.push({
                        line,
                        quantity: item.quantity,
                        selling_plan: '',
                    });
                }
            }

            if (!updates.length) return;

            for (const update of updates) {
                await fetch(theme.routes.cart_change_url, {
                    ...theme.utils.fetchConfig(),
                    body: JSON.stringify(update)
                });
            }

            const response = await fetch(theme.routes.cart_update_url, {
                ...theme.utils.fetchConfig(),
                body: JSON.stringify({
                    sections: this.getSectionsToRender().map(section => section.section)
                })
            });
            const updatedCart = await response.json();
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                source: 'subscribe-toggle',
                cart: updatedCart
            });
        } catch (error) {
            console.error('Error toggling subscription:', error);
        } finally {
            cartItemsContainer?.classList.remove('cart__items--disabled');
        }
    }

    filterUpsellProducts(cartJson) {
        if (!this.upsellProductsJson || !this.upsellProducts) return;

        const cartVariantIds = new Set(cartJson?.items?.map(item => item.variant_id) || []);
        this.upsellProducts.forEach((upsellEl) => {
            const variantId = upsellEl.getAttribute("data-variant-id");
            if (!variantId) return;

            const upsellEntry = this.upsellProductsJson.find(p => p.variant_id == variantId);
            if (!upsellEntry) return;

            const existsInCart = upsellEntry.variant_ids
                .some(id => cartVariantIds.has(Number(id)));

            upsellEl.classList.toggle("hidden", existsInCart);
        });

        const upsellWrapper = this.parentElement?.querySelector(".cart-upsell-wrapper")
            ?? document.querySelector(".cart-upsell-wrapper");
        if (!upsellWrapper) return;

        const items = upsellWrapper.querySelectorAll(".upsell-product-item");
        const anyVisible = items.length > 0 && Array.from(items).some((el) => !el.classList.contains("hidden"));
        upsellWrapper.classList.toggle("hidden", !anyVisible);
    }

    handleUpsellProducts() {
        if (!this.upsellProductsJson || !this.upsellProducts.length) return;

        this.upsellProducts.forEach(product => {
            const addButton = product.querySelector('.js-upsell-atc');
            if (!addButton || addButton.dataset.upsellInitialized) return;

            addButton.dataset.upsellInitialized = 'true';

            addButton.addEventListener('click', async (event) => {
                event.preventDefault();
                if (addButton.disabled) return;

                addButton.disabled = true;
                addButton.classList.add('active');
                addButton.querySelector('.cart-loader').classList.remove('hidden');

                const variantId = addButton.getAttribute('data-id');
                if (!variantId) return;

                const body = JSON.stringify({
                    id: variantId,
                    quantity: 1,
                    sections: this.getSectionsToRender().map(section => section.section)
                });

                await fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig(), ...{ body } })
                    .then((response) => response.json())
                    .then(async (parsedState) => {
                        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-cart-items', cart: parsedState });
                    })
                    .catch((error) => {
                        if (error.name === 'AbortError') {
                          console.log('Fetch aborted by user');
                        }
                        else {
                          console.error(error);
                          this.onCartError(error.message);
                        }
                      })
                    .finally(() => {
                        addButton.disabled = false;
                        addButton.classList.remove('active');
                        addButton.querySelector('.cart-loader').classList.add('hidden');
                    });
            });

        });
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    onChange(event) {
        if (event.target.classList.contains('js-subscribe-toggle')) return;
        if (!event.target.matches('.quantity__input')) return;
        this.validateQuantity(event);
    }

    onCartUpdate(event) {
        if (event.cart.errors) {
            this.updateLiveRegions(event.line, event.cart.errors);
            return;
        }

        const isEmpty = event.cart.item_count === 0;
        this.handleEmptyCart(isEmpty);

        if (isEmpty) {
            this.closest('mm-cart-drawer')?.classList.toggle('is-empty', isEmpty);
            this.addEmptyState();
        }

        const sectionsToRender = this.getSectionsToRender();

        sectionsToRender.forEach(section => {
            if (isEmpty && section.section !== 'header') return;

            const container = this.getSectionUpdateRoot(section);
            if (!container) return;

            const newHTML = event.cart.sections?.[section.section];
            if (!newHTML) return;

            const parsedHTML = this.getSectionInnerHTML(newHTML, section.selector);
            if (parsedHTML == null) return;

            const elementsToReplace = section.selector
                ? container.querySelectorAll(section.selector)
                : [container];

            elementsToReplace.forEach(el => {
                el.innerHTML = parsedHTML;
            });
        });

        this.syncHeaderCartIconFromCart(event.cart);

        (async () => {
            const cart = await this.getCartJSON();
            this.filterUpsellProducts(cart);
            this.updateProgressBar(cart);
        })();

        document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: {
                cart: event.cart
            }
        }));
    }

    addEmptyState() {
        const drawerInner = this.closest(".drawer__inner");
        if(!drawerInner) return;

        if (drawerInner.querySelector(".drawer__inner-empty")) {
            return;
        }

        drawerInner.insertAdjacentHTML(
            "beforeend",
            `
            <div class="drawer__inner-empty">
            <div class="cart-drawer__warnings">
                <div class="cart-drawer__empty-content">
                <h2 class="cart__empty-text">Your cart is empty</h2>
                <button class="drawer__close" type="button" onclick="this.closest('mm-cart-drawer').close()">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 12" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M12 12L2 2" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </button>
                <a href="/collections/all" class="mm-button">Continue Shopping</a>
                </div>
            </div>
            </div>
            `
        );
    }

    handleEmptyCart(isEmpty) {
        const drawer =this.closest('mm-cart-drawer');
        if(!drawer) return;

        const isEmptyClass = drawer.classList.contains('is-empty');
        if(!isEmpty && isEmptyClass) {
            drawer.classList.remove('is-empty');
            const emptyDiv = drawer?.querySelector('.drawer__inner-empty');
            if(emptyDiv) emptyDiv.remove();
        }
    }

    updateQuantity(line, quantity, name, target) {
        this.enableLoading(line);

        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map(section => section.section)
        });

        fetch(theme.routes.cart_change_url, { ...theme.utils.fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cart: parsedState, target, line, name });
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            }
            else {
              console.error(error);
              this.onCartError(error.message);
            }
          })
          .finally(() => {
            this.disableLoading(line);
          });
    }

    updateSellingPlan(line, sellingPlanId, event, variantId, quantity) {
        const lineNum = parseInt(line, 10);
        const qty = parseInt(quantity, 10);
        if (!lineNum || Number.isNaN(lineNum)) return;
        const safeQty = !Number.isNaN(qty) && qty > 0 ? qty : 1;

        this.enableLoading(lineNum);

        const payload = {
            line: lineNum,
            quantity: safeQty,
            sections: this.getSectionsToRender().map((section) => section.section),
        };

        if (sellingPlanId === '' || sellingPlanId === undefined || sellingPlanId === null) {
            payload.selling_plan = '';
        } else {
            payload.selling_plan = parseInt(sellingPlanId, 10);
        }

        fetch(theme.routes.cart_change_url, {
            ...theme.utils.fetchConfig(),
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((parsedState) => {
                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                    source: 'cart-items',
                    cart: parsedState,
                    target: event?.target,
                    line: lineNum,
                    name: 'selling_plan',
                });
            })
            .catch((error) => {
                if (error.name === 'AbortError') {
                    console.log('Fetch aborted by user');
                } else {
                    console.error(error);
                    this.onCartError(error.message);
                }
            })
            .finally(() => {
                this.disableLoading(lineNum);
            });
    }

    addProduct(id, cartJson) {
        const isInCart = cartJson.items.some(
            item => item.variant_id == id && item.properties?._progressbar_promotion
        );
        if(isInCart) return;

        const body = JSON.stringify({
            id: id,
            quantity: 1,
            properties: {
                _progressbar_promotion: 'true'
            },
            sections: this.getSectionsToRender().map(section => section.section)
        });
        
        fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig(), ...{ body } })
            .then((response) => response.json())
            .then((parsedState) => {
                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cart: parsedState });
            })
            .catch((error) => {
                console.error(error);
            });
    }

    removeProduct(id, cartJson) {
        const item = cartJson.items.find(item => item.variant_id == id && item.properties?._progressbar_promotion);
        if(!item) return;

        const body = JSON.stringify({
            id: item.key,
            quantity: 0,
            sections: this.getSectionsToRender().map(section => section.section)
        });
        
        fetch(theme.routes.cart_change_url, { ...theme.utils.fetchConfig(), ...{ body } })
            .then((response) => response.json())
            .then((parsedState) => {
                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cart: parsedState });
            })
            .catch((error) => {
                console.error(error);
            });
    }

    applyDiscountCode(code, cartJson) {
        if (cartJson.discount_codes.some(dc => dc.code === code)) return;

        const body = JSON.stringify({
            discount: code,
            sections: this.getSectionsToRender().map(section => section.section)
        });

        fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), ...{ body } })
            .then((response) => response.json())
            .then((parsedState) => {
                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cart: parsedState });
            })
            .catch((error) => {
                console.error(error);
            });
    }

    removeDiscountCode(code, cartJson) {
        const appliedCodes = cartJson.discount_codes.map(dc => dc.code);
        if (!appliedCodes.includes(code)) return;

        const remainingCodes = appliedCodes.filter(dc => dc !== code);
        const body = JSON.stringify({
            discount: remainingCodes.join(','),
            sections: this.getSectionsToRender().map(section => section.section)
        });

        fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), ...{ body } })
            .then((response) => response.json())
            .then((parsedState) => {
                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cart: parsedState });
            })
            .catch((error) => {
                console.error(error);
            });
    }

    validateQuantity(event) {
        const target = event.target;
        const inputValue = parseInt(target.value);
        const index = target.getAttribute('data-index');
        this.updateQuantity(index, inputValue, document.activeElement.getAttribute('name'), target);
    }

    enableLoading(line) {
        const mainCartItems = document.getElementById('mm-main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems?.classList.add('cart__items--disabled');


        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .cart-loader`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .cart-loader`);

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => {
        overlay.classList.remove('hidden');
        overlay.closest("mm-cart-remove-button")?.querySelector(".cart-remove-button")?.classList.add('hidden');
        });

        document.activeElement?.blur();
        this.lineItemStatusElement?.setAttribute('aria-hidden', false);
    }

    disableLoading(line) {
        const mainCartItems = document.getElementById('mm-main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems?.classList.remove('cart__items--disabled');
    
        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .cart-loader`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .cart-loader`);
    
        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => {
          overlay.classList.add('hidden');
          overlay.closest("mm-cart-remove-button")?.querySelector(".cart-remove-button")?.classList.remove('hidden');
        });
    }

    updateLiveRegions(line, message) {
        const lineItemError =
          document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
        if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;
    
        this.lineItemStatusElement?.setAttribute('aria-hidden', true);
    
        const cartStatus =
          document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        cartStatus?.setAttribute('aria-hidden', false);
    
        setTimeout(() => {
          cartStatus?.setAttribute('aria-hidden', true);
        }, 1000);
    }

    onCartError(errors) {
        this.querySelectorAll('.cart-loader').forEach(overlay => {
          overlay.classList.add('hidden');
          overlay.closest('mm-cart-remove-button')?.querySelector('.cart-remove-button')?.classList.remove('hidden');
        });
        this.showCartError(errors);
    }

    showCartError(message) {
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if(errors) errors.textContent = message;
    }

    syncHeaderCartIconFromCart(cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        const icon = document.querySelector('cart-icon.header-actions__cart-icon');
        if (!icon) return;
        const n = cart.item_count;
        icon.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
        const bubble = icon.querySelector('.cart-bubble');
        bubble?.classList.toggle('visually-hidden', n === 0);
        const countEl = icon.querySelector('.js-cart-indicator');
        countEl?.classList.toggle('hidden', n === 0);
    }

    getSectionUpdateRoot(section) {
        if (section.containerQuery) {
            return document.querySelector(section.containerQuery);
        }
        return document.getElementById(section.id);
    }

    getSectionInnerHTML(html, selector) {
        if (!html || !selector) return null;
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        return el ? el.innerHTML : null;
    }
    
    getSectionsToRender() {
        return [
          {
            id: 'CartDrawer',
            section: 'mm-cart-drawer',
            selector: 'mm-cart-items'
          },
          {
            id: 'CartDrawer',
            section: 'mm-cart-drawer',
            selector: '#main-cart-drawer-footer',
          },
          {
            id: 'CartDrawer',
            section: 'mm-cart-drawer',
            selector: '.mm-drawer__header',
          },
          {
            section: 'header',
            selector: '.js-cart-indicator',
            containerQuery: 'cart-icon.header-actions__cart-icon',
          }
        ];
    }

    getAttr(el, attr, isNumber = false) {
        const val = el.getAttribute(attr);
        if (val === null || val.trim() === '') return null;
        return isNumber ? Number(val) : val;
    };
}

customElements.define('mm-cart-items', MMCartItems);


class MMQuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));
        this.querySelectorAll('button').forEach((button) =>
            button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }

    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber();
        }
    }

    onInputChange(event) {
        this.validateQtyRules();
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        if (event.target.name === 'plus') {
            if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
                this.input.value = this.input.dataset.min;
            } else {
                this.input.stepUp();
            }
        } else {
            this.input.stepDown();
        }

        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

        if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
            this.input.value = parseInt(this.input.min);
        }
    }

    validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const buttonMinus = this.querySelector(".quantity__button[name='minus']");
            buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            const buttonPlus = this.querySelector(".quantity__button[name='plus']");
            buttonPlus.classList.toggle('disabled', value >= max);
        }
    }
}

customElements.define('mm-quantity-input', MMQuantityInput);

class MMSellingPlanButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('mm-cart-items') || this.closest('mm-cart-drawer-items');
        const index = this.closest('.mm-cart-item')?.dataset.index;
        const quantity = this.closest('.mm-cart-item')?.querySelector('.quantity__input')?.value;
  
        cartItems?.updateSellingPlan(index, this.dataset.sellingId, event, this.dataset.variantId, quantity);
      });
    }
  }
  
  customElements.define('mm-selling-plan-button', MMSellingPlanButton);
  
  class MMSellingPlanDropdown extends HTMLElement {
    constructor() {
      super();
      this._initialized = false;
      this._boundToggle = this.toggleDropdown.bind(this);
      this._boundOption = this.handleOptionClick.bind(this);
      this._boundClose = this.closeDropdown.bind(this);
    }

    connectedCallback() {
      if (this._initialized) return;
      this.trigger = this.querySelector('.spd-trigger');
      this.optionsContainer = this.querySelector('.spd-options');
      this.select = this.querySelector('select[name="selling_plan"]');

      if (!this.trigger || !this.optionsContainer) return;

      this.trigger.addEventListener('click', this._boundToggle);
      this.optionsContainer.addEventListener('click', this._boundOption);
      document.addEventListener('click', this._boundClose);
      this._initialized = true;
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._boundClose);
      this._initialized = false;
    }

    toggleDropdown(event) {
      event.preventDefault();
      event.stopPropagation();
      const willOpen = !this.classList.contains('active');
      this.classList.toggle('active', willOpen);
      this.optionsContainer?.classList.toggle('active', willOpen);
    }
  
    handleOptionClick(event) {
      const index = event.target.closest('.mm-cart-item')?.dataset.index;
  
      const option = event.target.closest('.spd-option');
      if (!option) return;
  
      const value = option.dataset.value;
  
      this.querySelectorAll('.spd-option').forEach(o => o.removeAttribute('data-selected'));
      option.setAttribute('data-selected', true);
  
      this.trigger.querySelector('.spd-text').textContent = option.querySelector('span').textContent;
      if (this.select) this.select.value = value;
      this.classList.remove('active');
      this.optionsContainer?.classList.remove('active');

      const cartItems = this.closest('mm-cart-items') || this.closest('mm-cart-drawer-items');
      const quantity = this.closest('.mm-cart-item')?.querySelector('.quantity__input')?.value;
  
      cartItems?.updateSellingPlan(index, value, event, this.dataset.variantId, quantity);
    }
  
    closeDropdown(event) {
      if (this.contains(event.target)) return;
      this.classList.remove('active');
      this.optionsContainer?.classList.remove('active');
    }
  }
  
  customElements.define('mm-selling-plan-dropdown', MMSellingPlanDropdown);